import React, { useState, useEffect } from 'react'
import {
  Button,
  Grid,
  TextField,
  Select,
  MenuItem,
  Input,
  FormControl,
  InputLabel
} from '@material-ui/core'
import { useParams } from 'react-router-dom'

import { onboarder } from '../../../api'
import Spinner from '../../Spinner/Spinner'
import DraggableTable from '../../DraggableTable/DraggableTable'

export default function ScriptsEdit () {
  document.title = 'Scripts | Superstruct Platform'

  const { id } = useParams()
  const [script, setScript] = useState(null)
  const [allArticles, setAllArticles] = useState([])
  const [articles, setArticles] = useState([])
  const [thrownError, setThrownError] = useState(null)
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    if (!script || !allArticles) return
    setLoaded(true)
    document.title = `${script.name} | Scripts | Superstruct Platform`
  }, [script, allArticles])

  useEffect(() => {
    onboarder.listScripts({ id }, (error, response) => {
      if (error) return setThrownError(error)
      if (response) {
        setScript(response[0])
        setArticles(response[0].articles)
      }
    })
    onboarder.listArticles((error, response) => {
      if (error) return setThrownError(error)
      setAllArticles(response.sort((a, b) => a.title.localeCompare(b.title)))
    })
  }, [id])

  if (thrownError) {
    return (
      <Grid>
        <Grid>{`ERROR: ${thrownError}`}</Grid>
      </Grid>
    )
  }

  if (!loaded) {
    return <Spinner />
  }

  const handleUpdate = () => {
    setLoaded(false)
    const newScript = {
      ...script,
      articles: articles.map((article) => article.id)
    }
    onboarder.updateScript(newScript, (error, response) => {
      if (error) {
        setThrownError(error)
        setLoaded(true)
        return
      }
      setScript(response)
      setLoaded(true)
    })
  }
  const handleChange = (event) => {
    const articleIds = event.target.value
    const articles = articleIds.map((id) =>
      allArticles.find((article) => article.id === id)
    )
    setArticles(articles)
  }
  const columns = [
    { name: 'title', label: 'Title' },
    { name: 'url', label: 'URL' },
    { name: 'body', label: 'Body' }
  ]

  return (
    <Grid>
      <>
        <form>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextField
                label='Name'
                value={script.name}
                onChange={(e) => setScript({ ...script, name: e.target.value })}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel id='script-articles'>Add articles</InputLabel>
                <Select
                  labelId='script-articles'
                  multiple
                  value={articles.map((a) => a.id)}
                  onChange={handleChange}
                  input={<Input />}
                  fullWidth
                >
                  {allArticles.map((article, index) => (
                    <MenuItem key={index} value={article.id}>
                      {article.title}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              {articles.length
                ? (
                  <DraggableTable
                    columns={columns}
                    rows={articles}
                    setRows={setArticles}
                    actions={['order', 'delete']}
                  />
                  )
                : null}
            </Grid>
            <Grid item xs={12}>
              <Button
                variant='contained'
                color='primary'
                onClick={handleUpdate}
              >
                Update
              </Button>
            </Grid>
          </Grid>
        </form>
      </>
    </Grid>
  )
}
